import React, { useEffect, useState } from 'react'

import essTeamServices from '../essTeamServices';
import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import LeaveRequestStatus from '../../../admin/erp/hrms/components/LeaveRequestStatus';
import moment from 'moment';
import { useAppData } from '../../../../context/AppDataContext';

function EssTeamLeaveRequest() {

    const {getMasterLabel} = useAppData();
    const [loading,setLoadingStatus] = useState(false)
    const [dialogStatus,setDialogStatus] = useState(false)
    const [teamLeaveRequestList,setTeamLeaveRequestList] = useState(null);

    const getLeaveRequestList = () =>{
        setLoadingStatus(true);
        essTeamServices.getTeamLeaveRequestList().then((res)=>{
            setTeamLeaveRequestList(res.data)
        }).catch(()=>{

        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getLeaveRequestList();
    },[])

    return (
        <>
            <button className='btn btn-mui-primary' onClick={()=>setDialogStatus(true)}>Leave Request 
                {teamLeaveRequestList?.length >0 ? 
                    ` (${teamLeaveRequestList.length})`:"" }
            </button>

            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogContent>
                    {teamLeaveRequestList?.length == 0&&
                        <div className="alert alert-info" role="alert">
                            <h4 className="alert-heading">Nothing Here</h4>
                            <p>No Leave Request Found</p>
                        </div>
                    }

                    {teamLeaveRequestList?.length > 0 && teamLeaveRequestList?.map(leaveRequest=>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='fw-bold text-primary'>{leaveRequest.employeeName}</div>
                                <div><span className='fw-bold'>{getMasterLabel("leave-type",leaveRequest.leaveType)}</span></div>
                                <div>
                                    <span className='fw-bold text-info'>{moment(leaveRequest.startDate).format("LL")}</span> 
                                    <span className='mx-2'>to</span> 
                                    <span className='fw-bold text-info'>{moment(leaveRequest.endDate).format("LL")}</span> 
                                    <span className='mx-2'>-</span>
                                    <span className='fw-bold text-danger'>(For {moment(leaveRequest.endDate).diff(moment(leaveRequest.startDate),"days")+1 } Day)</span>
                                </div>
                                <div>{leaveRequest.message}</div>
                            </div>
                            <div className='card-footer'>
                                <span className='float-end'><LeaveRequestStatus leaveRequest={leaveRequest} callBack={getLeaveRequestList} /></span>
                            </div>
                        </div>   
                    )}

                    
                </DialogContent>
                
            </Dialog>
            
        </>
    )
}

export default EssTeamLeaveRequest